<template>
  <div>
    <v-card>
      <v-card-title>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="tabActivo">
          <v-tab><b>Pop-up</b></v-tab>
          <v-tab><b>Logo</b></v-tab>
          <v-tab><b>Inscripciones</b></v-tab>
          <v-tab><b>Resultados</b></v-tab>
          <v-tab><b>Tarifas</b></v-tab>
          <v-tab><b>Puntajes</b></v-tab>
          <v-tab><b>Medallas</b></v-tab>
          <v-tab-item>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex d-flex>
                  <v-layout align-center>
                    <v-checkbox label="Mostrar pop-up" @change="activarPopup" v-model="registro.popup"></v-checkbox>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex d-flex>
                  <v-layout align-center>
                    <center><img :src="popupLink" /></center>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex d-flex>
                  <v-layout align-center>
                    <input
                      type="file"
                    	ref="popupFile"
                    	accept="image/png"
                    	@change="onSubirPopup"
                    	style="display: none;"
                  	>
                    <v-btn color="primary" @click="subirPopup()">Actualizar pop-up</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex d-flex>
                  <v-layout align-center>
                    <center><img :src="logoLink" /></center>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex d-flex>
                  <v-layout align-center>
                    <input
                      type="file"
                    	ref="logoFile"
                    	accept="image/png"
                    	@change="onSubirLogo"
                    	style="display: none;"
                  	>
                    <v-btn color="primary" @click="subirLogo()">Actualizar logo</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex d-flex>
                  <v-layout align-center>
                    <v-checkbox label="Activar inscripciones" @change="activarInscripciones" v-model="registro.inscripciones"></v-checkbox>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex d-flex>
                  <v-layout align-center>
                    <v-checkbox label="Activar resultados" @change="activarResultados" v-model="registro.resultados"></v-checkbox>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container grid-list-md>
              <v-flex xs12>
                <v-text-field label="Estatal" v-model="registroTarifas.estatal" :rules="requeridoRegla" mask="##.##"/>
                <v-text-field label="Privado" v-model="registroTarifas.privado" :rules="requeridoRegla" mask="##.##"/>
                <v-text-field label="Libre" v-model="registroTarifas.libre" :rules="requeridoRegla" mask="##.##"/>
                <v-btn color="primary" @click.native="guardarTarifas">Guardar</v-btn>
              </v-flex>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container grid-list-md>
              <v-layout row v-for="puntosGrado in registroPuntos" :key="puntosGrado.grado">
                <v-flex xs4>
                  <input type="hidden" v-model="puntosGrado.gradoAb"/>
                  <v-text-field label="Grado" v-model="puntosGrado.grado" :rules="requeridoRegla" disabled="disabled"/>
                </v-flex>
                <v-flex xs2>
                  <v-text-field label="Preguntas" v-model="puntosGrado.preguntas" :rules="requeridoRegla" />
                </v-flex>
                <v-flex xs2>
                  <v-text-field label="Correctas" v-model="puntosGrado.correctas" :rules="requeridoRegla" />
                </v-flex>
                <v-flex xs2>
                  <v-text-field label="Incorrectas" v-model="puntosGrado.incorrectas" :rules="requeridoRegla" />
                </v-flex>
                <v-flex xs2>
                  <v-text-field label="En blanco" v-model="puntosGrado.blanco" :rules="requeridoRegla" />
                </v-flex>
              </v-layout>
              <v-btn color="primary" @click.native="guardarPuntos">Guardar</v-btn>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container grid-list-md>
              <v-flex xs12>
                <v-text-field label="Primer puesto" v-model="registroMedallas.primer" :rules="requeridoRegla" />
                <v-text-field label="Segundo puesto" v-model="registroMedallas.segundo" :rules="requeridoRegla" />
                <v-text-field label="Tercer puesto" v-model="registroMedallas.tercer" :rules="requeridoRegla" />
                <v-text-field label="Cuarto puesto" v-model="registroMedallas.cuarto" :rules="requeridoRegla" />
                <v-text-field label="Quinto puesto" v-model="registroMedallas.quinto" :rules="requeridoRegla" />
                <v-text-field label="Sexto puesto" v-model="registroMedallas.sexto" :rules="requeridoRegla" />
                <v-btn color="primary" @click.native="guardarMedallas">Guardar</v-btn>
              </v-flex>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
      </v-card-actions>
    </v-card>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: () => ({
    tabActivo: 0,
    dialog: false,
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    headers: [],
    datos: [],
    registro: {popup: false, registro: 'I'},
    registroTarifas: {},
    registroPuntos: {},
    registroMedallas: {},
    lista: {},
    popupURL: '',
    popupArchivo: '',
    logoURL: '',
    logoArchivo: '',
    popupLink: `${process.env.API}/archivos/resultados2.png`,
    logoLink: `${process.env.API}/archivos/logo.png`
  }),
  computed: {
    popupSrc () {
      return `${process.env.API}/archivos/resultados2.png`
    },
    logoSrc () {
      return `${process.env.API}/archivos/logo.png`
    }
  },
  watch: {
  },
  created () {
    this.initialize()
    this.cargarConfiguracion()
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    cargarConfiguracion () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {codigo: this.registro.codigo}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              if (datos.d.popup === 't') this.registro.popup = true
              else this.registro.popup = false
              if (datos.d.etapa === 'I') this.registro.resultados = false
              else this.registro.resultados = true
              this.registroTarifas = datos.d.tarifas
              this.registroPuntos = datos.d.puntos
              this.registroMedallas = datos.d.medallas
            }
          }
        })
    },
    subirPopup () {
      this.$refs.popupFile.click()
    },
    subirLogo () {
      this.$refs.logoFile.click()
    },
    activarPopup (url, archivo) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro.popup
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=activarPopup`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              // this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    },
    registrarPopup (url, archivo) {
      this.popupURL = url
      this.registro.popup = encodeURIComponent(url)
      this.popupArchivo = archivo
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=subirPopup`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.registro = {}
            } else {
              alert(datos.m)
            }
          }
          this.popupLink = `${process.env.API}/archivos/resultados2.png?actualizar=` + Math.random()
        })
    },
    mostrarPopup (archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo)
      }
      return ''
    },
    onSubirPopup (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          var img = document.createElement('img')
          img.src = fr.result
          img.addEventListener('load', () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)

            var MAX_WIDTH = 1024
            var MAX_HEIGHT = 768
            var width = img.width
            var height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            this.registrarPopup(canvas.toDataURL(files[0].type), files[0])
          })
        })
      } else {
        this.popupArchivo = ''
        this.popupURL = ''
      }
    },
    activarResultados (url, archivo) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro.resultados
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=activarResultados`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              // this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    },
    activarInscripciones (url, archivo) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro.inscripciones
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=activarInscripciones`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              // this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    },
    registrarLogo (url, archivo) {
      this.logoURL = url
      this.registro.logo = encodeURIComponent(url)
      this.logoArchivo = archivo
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=subirLogo`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.registro = {}
            } else {
              alert(datos.m)
            }
          }
          this.$refs.logoFile.value = ''
          this.logoLink = `${process.env.API}/archivos/logo.png?actualizar=` + Math.random()
        })
    },
    mostrarLogo (archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo)
      }
      return ''
    },
    onSubirLogo (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          var img = document.createElement('img')
          img.src = fr.result
          img.addEventListener('load', () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)

            var MAX_WIDTH = 1024
            var MAX_HEIGHT = 768
            var width = img.width
            var height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            this.registrarLogo(canvas.toDataURL(files[0].type), files[0])
          })
        })
      } else {
        this.logoArchivo = ''
        this.logoURL = ''
      }
    },
    guardarTarifas (url, archivo) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registroTarifas
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=guardarTarifas`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              // this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    },
    guardarPuntos (url, archivo) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registroPuntos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=guardarPuntos`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              // this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    },
    guardarMedallas (url, archivo) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registroMedallas
      const myRequest = new Request(`${process.env.API}inicio.php?mod=configuracion&accion=guardarPuntosPuesto`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              // this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Configuracion.vue